import { defineStore } from 'pinia';

export const useTipStore = defineStore('tipStore', {
    state: () => ({
        showPopup: false,
        popupTitle: '',
        popupContent: ''
    }),
    actions: {
        openPopup(title, content) {
            this.popupTitle = title;
            this.popupContent = content;
            this.showPopup = true;
        },
        closePopup() {
            this.showPopup = false;
        },
        setPopupTitle(title) {
            this.popupTitle = title;
        },
        setPopupContent(content) {
            this.popupContent = content;
        }
    }
});
